import React from 'react';

/**
 * WhyWorkWithUs.jsx — full-bleed terracotta "stop moment". Self-contained.
 * Sits between Features and AboutUs to break the long beige run and give the
 * page a second high-contrast band after the dark StatsBand.
 */
const PROOF = [
  'Auckland-based team',
  'Live in weeks, not quarters',
  'We run it after go-live',
];

const WhyWorkWithUs = () => {
  const scrollToBooking = () => {
    const el = document.getElementById('booking');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/#booking';
    }
  };

  return (
    <section id="why-us" className="cai-wwu">
      <div className="cai-wwu-inner">
        <h2 className="cai-wwu-h2">Why work with us?</h2>

        <div className="cai-wwu-body">
          <p className="cai-wwu-p">
            We start with your actual operations — <b>not a technology pitch</b>. We scope what&apos;s
            realistic, deploy in weeks rather than quarters, and stay on after go-live to make sure
            it holds up in production.
          </p>
          <p className="cai-wwu-p">
            We&apos;re Auckland-based. We build and manage the stack ourselves, so when something needs
            attention, <b>you talk to the people who built it</b>.
          </p>

          <div className="cai-wwu-proof">
            {PROOF.map((p) => (
              <span key={p} className="cai-wwu-chip">{p}</span>
            ))}
          </div>
        </div>

        <div className="cai-wwu-foot">
          <div className="cai-wwu-rule" />
          <button type="button" className="cai-wwu-cta" onClick={scrollToBooking}>
            Work with us
          </button>
        </div>
      </div>

      <style>{`
        .cai-wwu { background: #C0492A; padding: 92px 40px 108px; }
        .cai-wwu-inner { max-width: 1080px; margin: 0 auto; display: grid; grid-template-columns: 0.95fr 1.05fr; gap: 30px 56px; align-items: start; }
        .cai-wwu-h2 { margin: 0; color: #fff; font-size: clamp(38px, 5.2vw, 60px); font-weight: 800; letter-spacing: -0.035em; line-height: 1; }
        .cai-wwu-body { padding-top: 8px; }
        .cai-wwu-p { margin: 0 0 20px; color: rgba(255,255,255,0.9); font-size: 18.5px; line-height: 1.68; max-width: 58ch; }
        .cai-wwu-p:last-of-type { margin-bottom: 0; }
        .cai-wwu-p b { color: #fff; font-weight: 700; }
        .cai-wwu-proof { display: flex; flex-wrap: wrap; gap: 10px; margin-top: 26px; }
        .cai-wwu-chip { font-size: 13px; font-weight: 600; color: #fff; border: 1px solid rgba(255,255,255,0.42); border-radius: 999px; padding: 7px 15px; }
        .cai-wwu-foot { grid-column: 1 / -1; margin-top: 14px; }
        .cai-wwu-rule { width: 46px; height: 3px; background: #EFD3C7; border-radius: 2px; margin-bottom: 22px; }
        .cai-wwu-cta { font-family: inherit; font-size: 14.5px; font-weight: 700; letter-spacing: 0.03em; color: #fff; background: transparent; border: 1.5px solid rgba(255,255,255,0.75); padding: 15px 34px; cursor: pointer; transition: background .18s ease, color .18s ease; }
        .cai-wwu-cta:hover { background: #fff; color: #C0492A; }
        .cai-wwu-cta:focus-visible { outline: 3px solid #fff; outline-offset: 3px; }
        @media (max-width: 860px) {
          .cai-wwu { padding: 62px 22px; }
          .cai-wwu-inner { grid-template-columns: 1fr; gap: 22px; }
        }
      `}</style>
    </section>
  );
};

export default WhyWorkWithUs;
